<template>
    <div id="app">
        <Header></Header>
        <div id="appContemt">
            <router-view />
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import tokenService from "../../service/tokenService";
import Header from "../../components/Header";
import Footer from "../../components/Footer.vue";

export default {
    name: "AdminLayout",
    components: { Header, Footer },
    beforeRouteEnter(to, from, next) {
        let curToken = tokenService.getToken();
        if (to.name !== "Signin" && !tokenService.isTokenValid(curToken))
            next({ name: "Signin" });
        else next();
    },
    created() {},
};
</script>

<style lang="scss" scoped>
</style>